import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Input from '../components/Input';

const schema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Email is required'),
  name: yup.string().required('Name is required'),
  description: yup.string().required('Description is required'),
  country: yup.string().required('Country is required'),
  acceptTerms: yup.boolean().oneOf([true], 'You must accept the terms'),
  gender: yup.string().required('Gender is required'),
});

const DemoForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    console.log('Form submitted:', data);
  };

  return (
    <div className="max-w-md mx-auto mt-10">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <Input
          label="Email"
          placeholder="you@example.com"
          {...register('email')}
          error={errors.email?.message}
        />

        <Input
          label="Name"
          placeholder="John Doe"
          {...register('name')}
          error={errors.name?.message}
        />

        <Input
          label="Description"
          placeholder="Write your message here..."
          as="textarea"
          rows={5}
          {...register('description')}
          error={errors.description?.message}
        />

        <Input
          label="Country"
          as="select"
          placeholder="Select a country"
          options={[
            { value: 'sg', label: 'Singapore' },
            { value: 'us', label: 'United States' },
            { value: 'in', label: 'India' },
          ]}
          {...register('country')}
          error={errors.country?.message}
        />

        {/* Checkbox example */}
        <Input
          label="I accept the terms and conditions"
          as="checkbox"
          {...register('acceptTerms')}
          error={errors.acceptTerms?.message}
        />

        {/* Radio buttons group (rendered individually) */}
        <div className="flex flex-col gap-2">
          <p className="text-sm font-medium text-gray-700 dark:text-gray-200">Gender</p>
          <Input
            id="gender_male"
            label="Male"
            as="radio"
            value="male"
            {...register('gender')}
            error={errors.gender?.message}
          />
          <Input
            id="gender_female"
            label="Female"
            as="radio"
            value="female"
            {...register('gender')}
            error={errors.gender?.message}
          />
          <Input
            id="gender_other"
            label="Other"
            as="radio"
            value="other"
            {...register('gender')}
            error={errors.gender?.message}
          />
          {errors.gender && (
            <p className="text-xs text-red-600 dark:text-red-500">{errors.gender.message}</p>
          )}
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default DemoForm;
